<script>

export default {

    name:'SharedTracking',

    methods: {
        trackPageView() {
        },
    },

    mounted() {
        setTimeout(() => this.trackPageView(), 250);

        this.$inertia.on('navigate', () => {
            setTimeout(() => this.trackPageView(), 250);
        });
    },

}

</script>
